import * as styles from "./ImageEditorBody.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Panel, type PanelProps } from "@frontend/components/atoms/Panel";

export function ImageEditorBody({
  className,
  ...props
}: PanelProps): JSX.Element {
  return (
    <Panel width="auto" className={clsx(styles.body, className)} {...props} />
  );
}
